"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LaunchDarklyConsumer = exports.LaunchDarklyProvider = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _React$createContext = _react2.default.createContext(),
    LaunchDarklyProvider = _React$createContext.Provider,
    LaunchDarklyConsumer = _React$createContext.Consumer;

exports.LaunchDarklyProvider = LaunchDarklyProvider;
exports.LaunchDarklyConsumer = LaunchDarklyConsumer;


//////////////////
// WEBPACK FOOTER
// ./~/react-launch-darkly/build/components/Context.js
// module id = 491
// module chunks = 0